export const DemoContent = [
  {
    name: "ACARS AAR",
    filePath:
      "/help-assets/resources/demoVideos/acarsProdDemoV11_cc_voice_admin_ann/acarsProdDemoV11_cc_voice_admin_ann_player.html",
  },
];
